export default "__VITE_ASSET__d4bb8ca7__"